import { Modal } from "pepsico-ds";
import PropTypes from "prop-types";

const DeleteConfirmationModal = ({
  isOpen,
  title = "Delete the item?",
  onConfirm,
  onCancel,
  className = "delete-modal",
  confirmText = "Yes, Delete",
  cancelText = "Cancel",
}) => {
  if (!isOpen) return null;

  return (
    <Modal
      showModal={isOpen}
      title={title}
      className={className}
      onCloseModal={onCancel}
      primaryButtonProps={{
        size: "medium",
        text: confirmText,
        variant: "primary",
        onClick: onConfirm,
      }}
      secondaryButtonProps={{
        size: "medium",
        text: cancelText,
        variant: "secondary",
        onClick: onCancel,
      }}
      showTertiaryButton={false}
      showLink={false}
    />
  );
};

DeleteConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  className: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
};

export default DeleteConfirmationModal;
